<template>
  <div
    :class="['p-3 bg-morado-oscuro borde-amarillo', tienePIE ? 'mb-2' : 'mb-4']"
  >
    <div id="summary">
      <span
        class="h5 text-white font-weight-bold px-0 text-center text-lg-left gilmer d-block"
        >Proyecto Educativo</span
      >
      <b-collapse id="texto-proyecto-educativo" class="mb-0 text-white">
        <p
          id="proyecto-educativo"
          class="text-justify mb-0"
          v-for="(text, index) in textoComputado"
          :key="index + '-parrafo-proyecto'"
        >
          {{ text }}
        </p>
      </b-collapse>
      <a
        v-b-toggle.texto-proyecto-educativo
        @click="
          $gtag.event('ver-resumen-proyecto-educativo', {
            event_category: 'proyecto-educativo',
            event_label: 'resumen-proyecto-educativo',
            value: ''
          })
        "
        id="boton-texto-proyecto-educativo"
        data-testid="boton-texto-proyecto-educativo"
        class="btn-secondary d-block mt-0 mb-2 btn btn-yellow font-weight-bold pointer"
      ></a>
    </div>

    <div class="row mt-3 pt-3 border-top border-azul-medio d-print-none">
      <div class="col-12 col-lg-6">
        <b-button
          :disabled="archivoProyecto ? false : true"
          id="descargar-proyecto"
          data-testid="descargar-proyecto"
          class="btn btn-yellow w-100 font-weight-bold"
          target="_blank"
          @click="
            $gtag.event('descargar-proyecto-educativo', {
              event_category: 'proyecto-educativo',
              event_label: 'descargar-proyecto-educativo',
              value: ''
            })
          "
          :href="urlDocumento(archivoProyecto)"
          ><FontAwesomeIcon icon="download" class="mr-2" />Proyecto
          Educativo</b-button
        >
      </div>
      <div class="col-12 col-lg-6">
        <b-button
          :disabled="reglamentoInterno ? false : true"
          id="descargar-reglamento"
          data-testid="descargar-reglamento"
          class="btn btn-yellow w-100 font-weight-bold mt-2 mt-lg-0"
          target="_blank"
          @click="
            $gtag.event('descargar-reglamento-interno', {
              event_category: 'reglamento-interno',
              event_label: 'descargar-reglamento-interno',
              value: ''
            })
          "
          :href="urlDocumento(reglamentoInterno)"
          ><FontAwesomeIcon icon="download" class="mr-2" />Reglamento
          Interno</b-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faDownload);
export default {
  components: {
    FontAwesomeIcon
  },
  props: {
    textoProyecto: {
      type: String,
      requiered: true,
      default: ""
    },
    archivoProyecto: {
      type: String,
      requiered: true
    },
    reglamentoInterno: {
      type: String,
      requiered: true
    },
    rbd: {
      type: Number,
      requiered: true
    },
    tienePIE: {
      type: Boolean,
      requiered: true
    }
  },
  data() {
    return {
      urlCdn: CDN,
      prefijoDocumentos: URL_DOCUMENTOS
    };
  },
  computed: {
    textoComputado() {
      return this.textoProyecto.split("\n");
    }
  },
  methods: {
    urlDocumento: function(documento) {
      return this.urlCdn + this.prefijoDocumentos + this.rbd + "/" + documento;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ficha/izquierda/ProyectoEducativo.vue